import type { HelpTopic } from '@horof/shared';

/** «؟ مساعدة», screen by screen (doc 52): short steps, the buttons' words. */
export const HELP: HelpTopic[] = [
  {
    path: '/',
    title: 'جولة القراءة',
    steps: [
      'اختر العداد من القائمة: الأرقام بترتيب الجولة.',
      'لا تجده؟ ابحث بالاسم أو برقم العداد.',
      '«لم تُقرأ» تعرض ما بقي، و«قُرئت» ما انتهيت منه.',
      'السهمان أعلى الشاشة يغيّران الشهر.',
    ],
  },
  {
    path: '/meter/:meterId',
    title: 'قراءة عداد',
    steps: [
      'اكتب الرقم الظاهر على العداد كما هو.',
      'إن طُلبت صورة، صوّر العداد عن قرب حتى يظهر الرقم بوضوح.',
      'اضغط «حفظ القراءة»، ثم انتقل إلى العداد التالي.',
      'أخطأت في الرقم؟ افتح العداد من «قُرئت» وصحّحه.',
    ],
  },
];
